import React from 'react'

import GridIcon from './Icon'

import { Props } from './types'

import {
  Wrap,
  Item,
  Title,
} from './styles'

const Grid: React.FC<Props> = ({ icons }): React.ReactElement => (
  <Wrap>
    {icons.map(icon => (
      <Item key={icon.title || icon.theme}>
        <GridIcon theme={icon.theme} />
        <Title>
          {icon.title || icon.theme}
        </Title>
      </Item>
    ))}
  </Wrap>
)

export default Grid
